import axios from 'axios';
import store from '../store';

axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if(response.data.message) {
        store.state.notifications.message = response.data.message;
    }
    if(response.data.success) {
        store.state.notifications.success = response.data.success;
    }
    store.state.notifications.errors = null;
    return response;
}, function (error) {
    const result = error.response;
    if (result && result.status === 422) {
        if(result.data.message) {
            store.state.notifications.message = result.data.message;
        }
        if(result.data.errors) {
            store.state.notifications.errors = result.data.errors;
        }
        store.state.notifications.success = false;
        store.state.loading.loading = store.state.loading.loading - 1
    }
    if (result && result.status === 500) {
        if(result.data.message) {
            store.state.notifications.message = result.data.message;
        }
        if(result.data.errors) {
            store.state.notifications.errors = result.data.errors;
        }
        store.state.notifications.success = false;
        store.state.loading.loading = store.state.loading.loading - 1
    }
    return Promise.reject(error);
});

export default axios;
